if( jQuery('.carousel-slides').length > 0 ){
  jQuery('.carousel-slides').slick({
    dots: true,
    arrows: true,
    infinite: false,
    //speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          //infinite: true,
          //dots: true
        }
      }
    ]
  });
}
if( jQuery('.collection-list-slider').length > 0 ){
  jQuery('.collection-list-slider').slick({
    dots: true,
    arrows: true,
    infinite: false,
    //speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          //infinite: true,
          //dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
} 
if( jQuery('.head-top .middle-part').length > 0 ){
  jQuery('.head-top .middle-part').slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
}
function wrapContentBoxes() {
  // Get the window width
  let windowWidth = jQuery(window).width();
        if ( jQuery('.collections-content-box-wrapper').length > 0 ) {
             if (windowWidth < 768) {
                let contentBoxes = jQuery('.collections-content-box-wrapper > .content-box');
                for (let i = 0; i < contentBoxes.length; i += 6) {
                  contentBoxes.slice(i, i + 6).wrapAll('<div class="group-collections-content-box-wrapper"></div>');
                }
                if( jQuery('.collections-content-box-wrapper').find('.group-collections-content-box-wrapper').length !== 0){
                    jQuery('.collections-content-box-wrapper').slick({
                    dots: true,
                    arrows: true,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  });
                 }
              } else {
                // If not in mobile view, remove wrappers
                 if( jQuery('.collections-content-box-wrapper').hasClass('slick-initialized') ){
                   jQuery('.collections-content-box-wrapper').slick('unslick');
                 }
                 if( jQuery('.collections-content-box-wrapper').find('.group-collections-content-box-wrapper').length !== 0){
                  jQuery('.collections-content-box-wrapper .content-box').unwrap();
                 } 
              }      
      }

       if ( jQuery('.shop-stones-box-wrapper').length > 0 ) {
             if (windowWidth < 768) {
                let contentBoxes = jQuery('.shop-stones-box-wrapper > .content-box');
                for (let i = 0; i < contentBoxes.length; i += 6) {
                  contentBoxes.slice(i, i + 6).wrapAll('<div class="group-shop-stones-box-wrapper"></div>');
                }
                if( jQuery('.shop-stones-box-wrapper').find('.group-shop-stones-box-wrapper').length !== 0){
                    jQuery('.shop-stones-box-wrapper').slick({
                    dots: true,
                    arrows: true,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  });
                 }
              } else {
                // If not in mobile view, remove wrappers
                 if( jQuery('.shop-stones-box-wrapper').hasClass('slick-initialized') ){
                   jQuery('.shop-stones-box-wrapper').slick('unslick');
                 }
                 if( jQuery('.shop-stones-box-wrapper').find('.group-shop-stones-box-wrapper').length !== 0){
                  jQuery('.shop-stones-box-wrapper .content-box').unwrap();
                 } 
              }      
      }


}




jQuery(document).ready(function () {
    // Call the function on page load and window resize
     wrapContentBoxes();
    jQuery(window).resize(wrapContentBoxes);
    
   // Announcement code
      // var $lis = jQuery('div.announcement-link-text');
      // var lis_count = $lis.length;
      // var active_li_index = 0;
  
      // setInterval(function(){
      //     var $active_li = $('div.announcement-link-text.active');
  
      //     if($lis.index($active_li) == lis_count - 1){
      //       active_li_index = 0;
      //     }else{
      //       active_li_index++;
      //     }
      //     $active_li.removeClass('active');
      //     $lis.eq(active_li_index).addClass('active');
      // }, 5000);
      // Split menu start
      var split_value = 23;
      jQuery('.mega-menu__list > li > .list-unstyled').each(function(){
      var total = jQuery(this).find("li").length;
      if( total > split_value ){
        var count = Math.ceil(total/split_value);
        //console.log(count);
         var column = 0;
          for (var i = 0; i < count; i++) {
            column++;
            jQuery(this).parent().append('<ul class="list-unstyled column' + column + '"></ul>');
            jQuery(this).parent().find(".column" + column).html(jQuery(this).find('li').splice(0, split_value));
          }
        jQuery(this).remove();
      }
    })
  // Split menu end
         
   //read more js
  jQuery('.js-read-more').each(function() {
    const $content = jQuery(this);
    const $paragraphs = $content.find('p');
    const numWords = parseInt($content.data('rm-words'));
    const $firstParagraph = $paragraphs.first();
    const originalText = $firstParagraph.text();
    let isTruncated = true;

    // Hide all paragraphs except the first one
    $paragraphs.slice(1).hide();

    if ($paragraphs.length > 1) {
      $content.append('<button class="read-more__button">Read More</button>');
    }

    $content.on('click', '.read-more__button', function() {
      const $button = jQuery(this);
      const $targetParagraphs = $paragraphs.slice(1);

      $targetParagraphs.slideToggle();
      $button.text(function(i, text) {
        return text === 'Read More' ? 'Read Less' : 'Read More';
      });

      isTruncated = !isTruncated;
      if (isTruncated) {
        $firstParagraph.text(truncateText(originalText, numWords));
      } else {
        $firstParagraph.text(originalText);
      }
    });

    // Function to truncate text to a maximum of specified number of words
    function truncateText(text, num) {
      const words = text.split(/\s+/);
      if (words.length > num) {
        return words.slice(0, num).join(' ') + '...';
      }
      return text;
    }

    // Truncate text for the first paragraph initially
    $firstParagraph.text(truncateText(originalText, numWords));
  });
 
}); 


var stickySidebar = jQuery('.product__media-wrapper');

if (stickySidebar.length > 0) { 
  var stickyHeight = stickySidebar.height(),
      sidebarTop = stickySidebar.offset().top;
}

// on scroll move the sidebar
jQuery(window).scroll(function () {
  if (stickySidebar.length > 0) { 
    var scrollTop = jQuery(window).scrollTop();
            
    if (sidebarTop < scrollTop) {
      stickySidebar.css('top', scrollTop - sidebarTop);

      // stop the sticky sidebar at the footer to avoid overlapping
      var sidebarBottom = stickySidebar.offset().top + stickyHeight,
          stickyStop = jQuery('.product__info-wrapper ').offset().top + jQuery('.product__info-wrapper ').height();
      if (stickyStop < sidebarBottom) {
        var stopPosition = jQuery('.product__info-wrapper').height() - stickyHeight;
        stickySidebar.css('top', stopPosition);
      }
    }
    else {
      stickySidebar.css('top', '0');
    } 
  }
});

jQuery(window).resize(function () {
  if (stickySidebar.length > 0) { 
    stickyHeight = stickySidebar.height();
  }
});


var btn = jQuery('.back-to-top');

jQuery(window).scroll(function() {
  if (jQuery(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  jQuery('html, body').animate({scrollTop:0}, '300');
});



function initLogoSlider() {
  if (jQuery(window).width() <= 1024) {
    if (!jQuery('.logo-slider').hasClass('slick-initialized')) {
      jQuery('.logo-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      });
    }
  } else {
    if (jQuery('.logo-slider').hasClass('slick-initialized')) {
      jQuery('.logo-slider').slick('unslick');
    }
  }
}
// Run on document ready
jQuery(document).ready(function () {
  initLogoSlider();
});
// Run on window resize
jQuery(window).on('resize', function () {
  initLogoSlider();
});


